import React from 'react';
import { Box } from '@mui/material';

/**
 * CompanyLogo — Displays the Dhanush company logo.
 * Props:
 *   size — 'sm' | 'md' | 'lg' | 'xl'  (default 'md')
 *   variant — 'default' | 'light' (for dark backgrounds)
 */
export default function CompanyLogo({ size = 'md', variant = 'default', sx = {} }) {
  const heights = { sm: 32, md: 44, lg: 56, xl: 72 };
  const logoHeight = heights[size] || heights.md;

  return (
    <Box
      component="img"
      src="/dhanush-logo.jpg"
      alt="Dhanush"
      loading="eager"
      decoding="async"
      sx={{
        height: logoHeight,
        width: 'auto',
        objectFit: 'contain',
        display: 'block',
        borderRadius: '4px',
        ...sx,
      }}
    />
  );
}
